import { render, staticRenderFns } from "./indexH5.vue?vue&type=template&id=f304ceb2&scoped=true&lang=pug"
import script from "./indexH5.vue?vue&type=script&lang=js"
export * from "./indexH5.vue?vue&type=script&lang=js"
import style0 from "./indexH5.vue?vue&type=style&index=0&id=f304ceb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f304ceb2",
  null
  
)

export default component.exports